module.exports = __webpack_public_path__ + "static/media/TC 4.1.cf9d688a.jpg";